import { render, staticRenderFns } from "./operate_process.vue?vue&type=template&id=2b7f3df6&scoped=true&"
import script from "./operate_process.vue?vue&type=script&lang=js&"
export * from "./operate_process.vue?vue&type=script&lang=js&"
import style0 from "./operate_process.vue?vue&type=style&index=0&id=2b7f3df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f3df6",
  null
  
)

export default component.exports